import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useApiError } from "../../../../common/errors/useApiError";
import { isForbiddenError } from "../../../../common/errors/isNoAccessError";
import { useAppDispatch } from "../../../../common/redux/hooks";
import { reloadMeThunk } from "../../../../common/redux/thunks/auth/reload-me-thunk";

export const useAccessChangeOutcome = () => {
  const myPersonId = useLoggedInWithOrgContextState().me.id;
  const dispatch = useAppDispatch();
  const displayer = useApiError();
  const toast = useToast();
  const { t } = useTranslation();

  const changed = useCallback(
    (personId: string) => {
      if (personId === myPersonId) void dispatch(reloadMeThunk());
    },
    [dispatch, myPersonId],
  );

  const refused = useCallback(
    (error: unknown) => {
      if (!isForbiddenError(error)) {
        displayer.trigger(error);
        return;
      }
      toast({
        description: t("You don't have access to change access in this organization any more."),
        status: "error",
      });
      void dispatch(reloadMeThunk());
    },
    [dispatch, displayer, t, toast],
  );

  return { changed, refused };
};
